/* =========================================================
   VERKOOP-HULPJES (productpagina)
   1. Levertijd-teller onder de bestelknop  (snippets/id4all-levertijd.liquid)
   2. Vaste bestelknop onderin op mobiel
   3. Preview loopt mee tijdens het typen op mobiel
   Aan/uit: Thema-instellingen > Verkoop-hulpjes  (doorgegeven via window.id4allVerkoop)
   Teksten: locales (product.levertijd_*, product.meeloop_sluiten)
   Opmaak:  assets/id4all-stijl.css (blok VERKOOP-HULPJES)
   ========================================================= */
(function () {
  'use strict';

  var CFG = window.id4allVerkoop || {};
  var T = window.translations || {};
  var MOBIEL = window.matchMedia('(max-width: 749px)');

  function tekst(key, fallback) {
    var v = T[key];
    return (!v || /translation missing/i.test(v)) ? fallback : String(v);
  }

  /* ======================================================
     1. LEVERTIJD-TELLER
     ====================================================== */
  /* Huidige tijd in Nederland, als "wandklok" in een UTC-datum */
  function nuNL() {
    var d = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { d[p.type] = p.value; });
    return new Date(Date.UTC(+d.year, +d.month - 1, +d.day, +d.hour, +d.minute, +d.second));
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function werkdag(d, feest) {
    var w = d.getUTCDay();
    return w >= 1 && w <= 5 && feest.indexOf(iso(d)) === -1;
  }

  function levertijd(el) {
    var sluit = (el.getAttribute('data-sluit') || '13:30').split(/[:.]/);
    var sh = parseInt(sluit[0], 10), sm = parseInt(sluit[1] || '0', 10);
    if (isNaN(sh)) { sh = 13; sm = 30; }
    var feest = (el.getAttribute('data-feest') || '').split(',').filter(Boolean);
    var taal = document.documentElement.lang || 'nl';

    function teken() {
      var nu = nuNL();
      var vandaag = new Date(Date.UTC(nu.getUTCFullYear(), nu.getUTCMonth(), nu.getUTCDate()));
      var grens = new Date(vandaag.getTime() + (sh * 60 + sm) * 60000);
      var uit;
      if (werkdag(vandaag, feest) && nu < grens) {
        var min = Math.max(1, Math.ceil((grens - nu) / 60000));
        var u = Math.floor(min / 60), m = min % 60;
        var tijd = u > 0
          ? tekst('levertijdUurMin', '[u] uur en [m] min').replace('[u]', u).replace('[m]', m)
          : tekst('levertijdMin', '[m] min').replace('[m]', m);
        uit = tekst('levertijdVandaag', 'Bestel binnen [tijd], dan versturen we hem vandaag nog.')
          .replace('[tijd]', '<strong>' + tijd + '</strong>');
      } else {
        var dag = new Date(vandaag.getTime() + 86400000), stap = 1;
        while (!werkdag(dag, feest) && stap < 30) { dag = new Date(dag.getTime() + 86400000); stap++; }
        if (stap === 1) {
          uit = tekst('levertijdMorgen', 'Bestel nu, dan versturen we hem morgen.');
        } else {
          var naam = new Intl.DateTimeFormat(taal, { weekday: 'long', timeZone: 'UTC' }).format(dag);
          if (stap > 6) naam += ' ' + new Intl.DateTimeFormat(taal, { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(dag);
          uit = tekst('levertijdDag', 'Bestel nu, dan versturen we hem op [dag].').replace('[dag]', naam);
        }
      }
      el.innerHTML = '<span class="id4all-levertijd__icoon" aria-hidden="true"></span><span>' + uit + '</span>';
      el.hidden = false;
    }
    teken();
    setInterval(teken, 30000);
  }

  /* ======================================================
     2. VASTE BESTELKNOP ONDERIN (MOBIEL)
     ====================================================== */
  function stickyKnop() {
    var orig = document.querySelector('product-info .product-form__submit, .product__info-container .product-form__submit');
    if (!orig) return;
    var info = orig.closest('product-info, .product__info-container') || document;

    var balk = document.createElement('div');
    balk.className = 'id4all-sticky-knop';
    balk.hidden = true;
    balk.innerHTML =
      '<div class="id4all-sticky-knop__info"><span class="id4all-sticky-knop__titel"></span>' +
      '<span class="id4all-sticky-knop__prijs"></span></div>' +
      '<button type="button" class="button button--primary id4all-sticky-knop__knop"></button>';
    document.body.appendChild(balk);
    var titelEl = balk.querySelector('.id4all-sticky-knop__titel');
    var prijsEl = balk.querySelector('.id4all-sticky-knop__prijs');
    var knop = balk.querySelector('button');

    function vul() {
      var t = info.querySelector('.product__title h1, .product__title h2, h1');
      titelEl.textContent = t ? t.textContent.trim() : '';
      var p = info.querySelector('.price');
      var item = p && (p.classList.contains('price--on-sale')
        ? p.querySelector('.price-item--sale')
        : p.querySelector('.price__regular .price-item--regular'));
      prijsEl.textContent = item ? item.textContent.trim() : '';
      var label = orig.querySelector('span:not(.hidden):not(.sold-out-message)') || orig;
      knop.textContent = label.textContent.trim();
      knop.disabled = orig.disabled || orig.getAttribute('aria-disabled') === 'true' && !orig.classList.contains('loading');
    }

    function typt() {
      var a = document.activeElement;
      return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && a.type !== 'radio' && a.type !== 'checkbox';
    }

    function check() {
      var drawerOpen = document.querySelector('cart-drawer.active, cart-drawer[open], .drawer.active');
      var r = orig.getBoundingClientRect();
      var voorbij = r.bottom < 0;
      var tonen = MOBIEL.matches && voorbij && !typt() && !drawerOpen;
      if (tonen && balk.hidden) vul();
      balk.hidden = !tonen;
      document.body.classList.toggle('id4all-sticky-knop-actief', tonen);
    }

    knop.addEventListener('click', function () {
      orig.scrollIntoView({ behavior: 'smooth', block: 'center' });
      /* Klik op de echte knop: zo gelden alle controles (maat, tekstlengte, cross-sell) */
      setTimeout(function () { orig.click(); }, 350);
    });

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    document.addEventListener('focusin', check);
    document.addEventListener('focusout', function () { setTimeout(check, 50); });
    MOBIEL.addEventListener && MOBIEL.addEventListener('change', check);
    new MutationObserver(function () { if (!balk.hidden) vul(); })
      .observe(info, { subtree: true, childList: true, characterData: true });
    check();
  }

  /* ======================================================
     3. PREVIEW LOOPT MEE TIJDENS HET TYPEN (MOBIEL)
     v23: per soort product
       - stof, kidscord, duo-color, ID-band: de visualisatie-foto, witruimte boven/onder
         automatisch weggesneden (lager voorbeeld, grotere tekst)
       - siliconen (1 kleur) en QR: een smalle balk met de tekst in het gravure-lettertype
         (geen foto, dus geen verkeerde indruk van de graveerkleur)
     Springt niet (geen automatisch scrollen); vervaagt tijdens scrollen; pijltje onderaan om weg te schuiven.
     Per soort product uit te zetten in de productsectie (vinkje 'Meelopend voorbeeld').
     ====================================================== */
  var IDS = [
    'silicone-text-1', 'silicone-text-2',
    'fabric-text-icons-1-no-qr', 'fabric-text-line-1-no-qr', 'fabric-text-line-2-no-qr',
    'fabric-text-line-3-no-qr', 'fabric-text-line-4-no-qr',
    'qr-text-input', 'qr-text-input-2'
  ];
  var MAX_HOOGTE = 115; /* px: hoogte van het (bijgesneden) foto-voorbeeld */
  var DICHT_KEY = 'id4all-meeloop-dicht';
  var MODUS = CFG.meeloopScroll || 'bijsturen'; /* vervagen | bijsturen | vast (Thema-instellingen > Verkoop-hulpjes) */
  var PIJL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Welke velden horen bij de tekstbalk */
  var BALK_VELDEN = {
    silicone: ['silicone-text-1', 'silicone-text-2'],
    qr: ['qr-text-input', 'qr-text-input-2']
  };

  function meeloop() {
    /* Per soort product uit te zetten: vinkje in de productsectie (zet data-id4all-meeloop-uit) */
    if (document.querySelector('[data-id4all-meeloop-uit]')) return;
    var paneel = document.createElement('div');
    paneel.className = 'id4all-meeloop';
    paneel.hidden = true;
    paneel.innerHTML = '<div class="id4all-meeloop__vlak"></div>' +
      '<div class="id4all-meeloop__balk"></div>' +
      '<button type="button" class="id4all-meeloop__greep">' + PIJL + '</button>';
    document.body.appendChild(paneel);
    var vlak = paneel.querySelector('.id4all-meeloop__vlak');
    var balk = paneel.querySelector('.id4all-meeloop__balk');
    var greep = paneel.querySelector('.id4all-meeloop__greep');
    var laatsteIcoon = 0, gepland = false, timer = null, laatsteVeld = null;

    /* --- Inklappen / uitklappen met het pijltje --- */
    function ingeklapt() { try { return sessionStorage.getItem(DICHT_KEY) === '1'; } catch (e) { return false; } }
    function zetKlap(dicht) {
      try { sessionStorage.setItem(DICHT_KEY, dicht ? '1' : '0'); } catch (e) {}
      paneel.classList.add('is-anim');
      setTimeout(function () { paneel.classList.remove('is-anim'); }, 300);
      toonKlap();
    }
    function toonKlap() {
      var dicht = ingeklapt();
      paneel.classList.toggle('is-ingeklapt', dicht);
      greep.setAttribute('aria-label', dicht ? tekst('meeloopTonen', 'Voorbeeld tonen') : tekst('meeloopSluiten', 'Voorbeeld verbergen'));
      greep.setAttribute('aria-expanded', dicht ? 'false' : 'true');
    }
    var startY = null;
    greep.addEventListener('pointerdown', function (e) { startY = e.clientY; });
    greep.addEventListener('pointerup', function (e) {
      if (startY === null) return;
      var dy = e.clientY - startY; startY = null;
      if (dy < -15) zetKlap(true);        /* omhoog geveegd: wegschuiven */
      else if (dy > 15) zetKlap(false);   /* omlaag geveegd: terughalen */
      else zetKlap(!ingeklapt());         /* getikt: wisselen */
      e.preventDefault();
    });
    greep.addEventListener('click', function (e) { if (e.detail === 0) zetKlap(!ingeklapt()); }); /* toetsenbord */
    /* Tikken op het pijltje mag het tekstveld niet laten loslaten (anders sluit het toetsenbord) */
    greep.addEventListener('mousedown', function (e) { e.preventDefault(); });
    greep.addEventListener('touchstart', function (e) { e.preventDefault(); }, { passive: false });

    /* --- Soort: tekstbalk (siliconen 1 kleur, QR) of foto (de rest) --- */
    function soort() {
      var a = laatsteVeld;
      if (a && BALK_VELDEN.qr.indexOf(a.id) !== -1) return 'qr';
      var main = document.querySelector('[product-template]');
      var tpl = main ? main.getAttribute('product-template') : '';
      if (a && BALK_VELDEN.silicone.indexOf(a.id) !== -1 && tpl === 'product.silicone') return 'silicone';
      return 'foto';
    }

    function bron() {
      var lijst = document.querySelectorAll('.live-preview-overlay');
      for (var i = 0; i < lijst.length; i++) {
        if (paneel.contains(lijst[i])) continue;
        if (lijst[i].offsetParent !== null) return lijst[i].closest('.product__media') || lijst[i].parentElement;
      }
      return null;
    }
    function bezig() {
      var a = document.activeElement;
      return (a && IDS.indexOf(a.id) !== -1) || (Date.now() - laatsteIcoon < 5000);
    }

    /* --- Tekstbalk vullen: label (zoals boven het veld, zonder de uitleg tussen haakjes) + tekst --- */
    function vulBalk(s) {
      var data = [], iets = false, font = '';
      BALK_VELDEN[s].forEach(function (id) {
        var veld = document.getElementById(id);
        if (!veld || veld.offsetParent === null) return;
        if (!font) font = getComputedStyle(veld).fontFamily;
        var lab = document.querySelector('label[for="' + id + '"]');
        if (veld.value.trim() !== '') iets = true;
        data.push([lab ? lab.textContent.split('(')[0].trim() : '', veld.value]);
      });
      balk.replaceChildren();
      data.forEach(function (rij) {
        var l = document.createElement('span'); l.className = 'id4all-meeloop__label'; l.textContent = rij[0];
        var t = document.createElement('span'); t.className = 'id4all-meeloop__tekst'; t.textContent = rij[1] || String.fromCharCode(160);
        t.style.fontFamily = font;
        balk.appendChild(l); balk.appendChild(t);
      });
      return iets;
    }

    /* --- Witruimte boven/onder het bandje bepalen (per foto 1x), tekst nooit wegsnijden --- */
    var snijCache = {};
    function zichtbareFoto(media) {
      var beste = null, opp = 0;
      media.querySelectorAll('img').forEach(function (i) {
        if (getComputedStyle(i).display === 'none') return;
        var o = i.offsetWidth * i.offsetHeight;
        if (o > opp) { opp = o; beste = i; }
      });
      return beste;
    }
    function snij(media) {
      var res = { boven: 0, onder: 1 };
      var img = zichtbareFoto(media);
      if (img && img.complete && img.naturalWidth) {
        var key = img.currentSrc || img.src;
        if (!(key in snijCache)) {
          snijCache[key] = null;
          try {
            var W = 120, H = Math.max(1, Math.round(W * img.naturalHeight / img.naturalWidth));
            var c = document.createElement('canvas'); c.width = W; c.height = H;
            var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, W, H);
            var d = ctx.getImageData(0, 0, W, H).data, eerste = -1, laatste = -1;
            for (var y = 0; y < H; y++) {
              var vol = 0;
              for (var x = 0; x < W; x++) {
                var p = (y * W + x) * 4;
                if (d[p + 3] > 40 && (d[p] < 232 || d[p + 1] < 232 || d[p + 2] < 232)) vol++;
              }
              if (vol > W * 0.03) { if (eerste < 0) eerste = y; laatste = y; }
            }
            if (eerste >= 0) snijCache[key] = { boven: eerste / H, onder: (laatste + 1) / H };
          } catch (e) { /* foto van ander domein: niet bijsnijden */ }
        }
        if (snijCache[key]) res = { boven: snijCache[key].boven, onder: snijCache[key].onder };
      }
      /* Tekst in het voorbeeld altijd binnen beeld houden */
      var mr = media.getBoundingClientRect();
      if (mr.height) {
        media.querySelectorAll('.live-preview-overlay [class*="preview-text"]').forEach(function (s) {
          if (!s.textContent.trim() || s.offsetParent === null) return;
          var r = s.getBoundingClientRect();
          res.boven = Math.min(res.boven, (r.top - mr.top) / mr.height);
          res.onder = Math.max(res.onder, (r.bottom - mr.top) / mr.height);
        });
      }
      res.boven = Math.max(0, res.boven - 0.04);
      res.onder = Math.min(1, res.onder + 0.04);
      if (res.onder - res.boven < 0.15) return { boven: 0, onder: 1 };
      return res;
    }

    /* Alle foto's in de kopie gelijk houden aan het origineel (ook de visualisatie-foto die
       bovenop de productfoto ligt en pas later van bron wisselt) */
    function fotos(media, kop) {
      var o = media.querySelectorAll('img'), k = kop.querySelectorAll('img');
      for (var i = 0; i < o.length && i < k.length; i++) {
        /* Zelfde zichtbaarheid als het origineel: tijdens typen verbergt het thema de productfoto
           en toont het de visualisatie-foto (metaveld) met style="display:..." */
        var stijl = o[i].getAttribute('style') || '';
        if ((k[i].getAttribute('style') || '') !== stijl) k[i].setAttribute('style', stijl);
        var src = o[i].currentSrc || o[i].src;
        if (!src) continue;
        if (k[i].getAttribute('srcset') !== null) { k[i].removeAttribute('srcset'); k[i].removeAttribute('sizes'); }
        k[i].removeAttribute('loading');
        if (k[i].src !== src) k[i].src = src;
      }
    }

    /* --- Kopie maken: alleen bij nieuwe tekst of andere foto, NIET bij scrollen (anders knippert het) --- */
    var huidigeBron = null, kopie = null;
    function kopieer(media) {
      var w = media.offsetWidth, h = media.offsetHeight;
      if (!w || !h) return false;
      if (media !== huidigeBron || !kopie) {
        kopie = media.cloneNode(true);
        kopie.removeAttribute('id');
        kopie.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        kopie.style.margin = '0';
        kopie.style.transformOrigin = 'top left';
        vlak.replaceChildren(kopie);
        huidigeBron = media;
      } else {
        /* Alleen de tekstlaag vervangen, de foto blijft staan */
        var oOv = media.querySelector('.live-preview-overlay'), kOv = kopie.querySelector('.live-preview-overlay');
        if (oOv && kOv) kOv.replaceWith(oOv.cloneNode(true));
      }
      fotos(media, kopie);
      var s = snij(media);
      var deelH = (s.onder - s.boven) * h;
      var schaal = Math.min(1, MAX_HOOGTE / deelH, (window.innerWidth - 32) / w);
      kopie.style.width = w + 'px';
      kopie.style.height = h + 'px';
      kopie.style.transform = 'translateY(' + (-s.boven * h * schaal) + 'px) scale(' + schaal + ')';
      vlak.style.width = Math.round(w * schaal) + 'px';
      vlak.style.height = Math.round(deelH * schaal) + 'px';
      return true;
    }

    /* --- Tonen of verbergen (goedkoop, mag bij elke scroll) --- */
    function zichtbaar(media, s) {
      if (!MOBIEL.matches || !bezig()) return false;
      /* v23b: ook zichtbaar blijven als het veld met de cursor buiten beeld gescrold is */
      if (!media) return false;
      var r = media.getBoundingClientRect();
      /* Twee grenzen tegen knipperen: pas tonen als de foto echt weg is, pas verbergen als hij weer goed zichtbaar is */
      return paneel.hidden ? r.bottom < 60 : r.bottom < 160;
    }

    function teken(nieuw) {
      gepland = false;
      var a = document.activeElement;
      if (a && IDS.indexOf(a.id) !== -1) laatsteVeld = a;
      var s = soort();
      var media = bron();
      if (!zichtbaar(media, s)) { paneel.hidden = true; return; }
      var wasVerborgen = paneel.hidden;
      var isBalk = s !== 'foto';
      paneel.classList.toggle('id4all-meeloop--balk', isBalk);
      if (isBalk) {
        if (!vulBalk(s)) { paneel.hidden = true; return; }
        huidigeBron = null; kopie = null; vlak.replaceChildren();
      } else {
        balk.replaceChildren();
        if ((nieuw || wasVerborgen || media !== huidigeBron) && !kopieer(media)) { paneel.hidden = true; return; }
      }
      paneel.hidden = false;
      if (wasVerborgen) toonKlap();
      plaats();
    }
    var nieuwSoort = false;
    function plan(soort) {
      if (soort) nieuwSoort = nieuwSoort || soort;
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(function () { var n = nieuwSoort; nieuwSoort = false; teken(n); });
    }

    /* iPhone: met het toetsenbord open schuift de zichtbare ruimte; paneel bovenaan die ruimte houden.
       Elke beeldfrequentie bijwerken tijdens het scrollen (de scroll-meldingen van iPhone komen te laat) */
    var vvLaatst = -1, lusTot = 0, lusAan = false;
    paneel.style.willChange = 'transform';
    function plaats() {
      var vv = window.visualViewport;
      var y = (vv && MODUS !== 'vast') ? Math.max(0, Math.round(vv.offsetTop)) : 0;
      if (y !== vvLaatst) { vvLaatst = y; paneel.style.setProperty('--meeloop-vv', y + 'px'); }
    }
    function volg() {
      lusTot = Date.now() + 700;
      if (lusAan || paneel.hidden) return;
      lusAan = true;
      (function stap() {
        plaats();
        if (Date.now() < lusTot && !paneel.hidden) requestAnimationFrame(stap); else lusAan = false;
      })();
    }
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', plaats);
      window.visualViewport.addEventListener('scroll', volg);
    }
    /* Tijdens scrollen even vervagen: zo zie je het voorbeeld nooit meeschuiven */
    var scrollTimer = null;
    function vervaag() {
      if (paneel.hidden || MODUS !== 'vervagen') return;
      paneel.classList.add('is-scrollt');
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { plaats(); paneel.classList.remove('is-scrollt'); }, 200);
    }
    window.addEventListener('scroll', vervaag, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('scroll', vervaag);
    window.addEventListener('scroll', volg, { passive: true });
    window.addEventListener('touchmove', volg, { passive: true });
    window.addEventListener('touchend', volg, { passive: true });

    document.addEventListener('input', function (e) { if (IDS.indexOf(e.target.id) !== -1) plan('veld'); });
    document.addEventListener('focusin', function (e) { if (IDS.indexOf(e.target.id) !== -1) plan('veld'); });
    document.addEventListener('focusout', function () { setTimeout(function () { plan(); }, 100); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#fun-icons-keyboard, #medical-icons-keyboard')) {
        laatsteIcoon = Date.now();
        setTimeout(function () { plan('tekst'); }, 50);
        clearTimeout(timer);
        timer = setTimeout(function () { plan(); }, 5100);
      }
    });
    window.addEventListener('scroll', function () { plan(); }, { passive: true });
    /* Voorbeeld vernieuwen als de tekst of de foto in het grote voorbeeld verandert */
    new MutationObserver(function (list) {
      if (paneel.hidden) return;
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target.nodeType === 1 ? list[i].target : list[i].target.parentElement;
        if (n && !paneel.contains(n) && n.closest && n.closest('.live-preview-overlay, .product__media')) { plan('tekst'); return; }
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class', 'src', 'srcset'] });
  }

  /* ======================================================
     4. TELEFOONNUMMER CONTROLEREN (v24)
     Kijkt pas als de klant een tekstveld verlaat. Herkent mobiele nummers uit
     NL (06, 10 cijfers), BE (04, 10 cijfers) en DE (015/016/017, 11 of 12 cijfers),
     ook met +31/+32/+49 of 0031/0032/0049. Andere nummers: geen melding.
     Optioneel (Thema-instellingen > Verkoop-hulpjes): ook bij de bestelknop
     (eerste druk toont de melding, tweede druk bestelt).
     ====================================================== */
  var TEL_TEKST = {
    nl: { kort: 'Klopt dit nummer? Er lijkt een cijfer te weinig in te staan.', lang: 'Klopt dit nummer? Er lijkt een cijfer te veel in te staan.', nul: 'Na [land] hoort de 0 weg: [land] [eerste]… in plaats van [land] 0[eerste]…', knop: 'Klopt het toch? Druk nogmaals op de knop om te bestellen.' },
    de: { kort: 'Stimmt diese Nummer? Es scheint eine Ziffer zu fehlen.', lang: 'Stimmt diese Nummer? Es scheint eine Ziffer zu viel zu sein.', nul: 'Nach [land] entfällt die 0: [land] [eerste]… statt [land] 0[eerste]…', knop: 'Stimmt sie doch? Drücken Sie noch einmal auf den Button, um zu bestellen.' },
    fr: { kort: 'Ce numéro est-il correct ? Il semble manquer un chiffre.', lang: 'Ce numéro est-il correct ? Il semble y avoir un chiffre en trop.', nul: 'Après [land], le 0 disparaît : [land] [eerste]… au lieu de [land] 0[eerste]…', knop: 'Il est correct ? Appuyez à nouveau sur le bouton pour commander.' },
    en: { kort: 'Is this number correct? It seems to be missing a digit.', lang: 'Is this number correct? It seems to have one digit too many.', nul: 'After [land] the 0 is dropped: [land] [eerste]… instead of [land] 0[eerste]…', knop: 'Is it correct? Press the button again to order.' }
  };
  function telTekst(key) {
    var taal = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    return (TEL_TEKST[taal] || TEL_TEKST.nl)[key];
  }
  /* Geeft null (geen probleem of niet herkend) of { soort: 'kort'|'lang'|'nul', land, eerste } */
  function telProbleem(waarde) {
    var stukken = [];
    (String(waarde || '').match(/(?:\+|00)?\d[\d\s\-.\/()]{5,}\d/g) || []).forEach(function (blok) {
      /* Twee nummers achter elkaar ("0612345678 0687654321") apart bekijken */
      var huidig = '';
      blok.trim().split(/\s+/).forEach(function (g) {
        if (huidig && /^(\+|0)/.test(g) && huidig.replace(/\D/g, '').length >= 9) { stukken.push(huidig); huidig = g; }
        else huidig = huidig ? huidig + ' ' + g : g;
      });
      if (huidig) stukken.push(huidig);
    });
    for (var i = 0; i < stukken.length; i++) {
      var ruw = stukken[i].trim();
      var intl = /^(\+|00)/.test(ruw);
      var cijfers = ruw.replace(/\D/g, '');
      if (ruw.indexOf('00') === 0) cijfers = cijfers.slice(2);
      var nat = null, land = '';
      if (intl) {
        var cc = cijfers.slice(0, 2);
        if (cc !== '31' && cc !== '32' && cc !== '49') continue;
        land = '+' + cc;
        var rest = cijfers.slice(2);
        if (rest.charAt(0) === '0') return { soort: 'nul', land: land, eerste: rest.charAt(1) };
        nat = '0' + rest;
      } else {
        nat = cijfers;
      }
      var min, max;
      if (/^06/.test(nat) && (!land || land === '+31')) { min = max = 10; }
      else if (/^04/.test(nat) && (!land || land === '+32')) { min = max = 10; }
      else if (/^01[5-7]/.test(nat) && (!land || land === '+49')) { min = 11; max = 12; }
      else continue;
      if (nat.length < min) return { soort: 'kort' };
      if (nat.length > max) return { soort: 'lang' };
    }
    return null;
  }

  function telefoonCheck() {
    var VELDEN = IDS.concat(['qr-code-phone-text-input']);
    var bevestigd = false;
    function melding(veld) {
      var m = veld._telMelding;
      if (!m) {
        m = document.createElement('p');
        m.className = 'id4all-telcheck';
        m.setAttribute('role', 'status');
        m.hidden = true;
        var na = veld.nextElementSibling && veld.nextElementSibling.classList.contains('gravure-status') ? veld.nextElementSibling : veld;
        na.insertAdjacentElement('afterend', m);
        veld._telMelding = m;
      }
      return m;
    }
    function check(veld, metKnopTekst) {
      var p = telProbleem(veld.value);
      var m = veld._telMelding;
      if (!p) { if (m) { m.hidden = true; m.classList.remove('is-knop'); } return false; }
      m = melding(veld);
      var t = telTekst(p.soort);
      if (p.soort === 'nul') t = t.split('[land]').join(p.land).split('[eerste]').join(p.eerste);
      if (metKnopTekst) t += ' ' + telTekst('knop');
      m.textContent = t;
      m.hidden = false;
      m.classList.toggle('is-knop', !!metKnopTekst);
      return true;
    }
    /* Pas na het verlaten van het veld; daarna live bijwerken zodra het klopt */
    document.addEventListener('focusout', function (e) {
      if (VELDEN.indexOf(e.target.id) !== -1) check(e.target, false);
    });
    document.addEventListener('input', function (e) {
      var v = e.target;
      if (VELDEN.indexOf(v.id) !== -1 && v._telMelding && !v._telMelding.hidden) check(v, v._telMelding.classList.contains('is-knop'));
      bevestigd = false;
    });

    /* Stap 2 (standaard uit): bij de bestelknop */
    if (!CFG.telefoonKnop) return;
    document.addEventListener('click', function (e) {
      var knop = e.target.closest && e.target.closest('.product-form__submit, [name="add"]');
      if (!knop || bevestigd) return;
      var fout = null;
      VELDEN.forEach(function (id) {
        var v = document.getElementById(id);
        if (v && v.offsetParent !== null && telProbleem(v.value) && !fout) fout = v;
      });
      if (!fout) return;
      e.preventDefault(); e.stopImmediatePropagation();
      bevestigd = true;
      check(fout, true);
      fout.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  }

  /* ======================================================
     5. EIGEN ONTWERP IN DE WINKELWAGEN (v24)
     Tijdens het ontwerpen wordt een plaatje gemaakt van het voorbeeld (foto + tekst)
     en in deze browser bewaard. In de winkelwagen staat dat plaatje op volle breedte boven
     de regel met precies dezelfde variant en tekst. Niets wordt verstuurd of opgeslagen
     op de server; lukt het niet, dan blijft gewoon de productfoto staan.
     ====================================================== */
  var ONTWERP_KEY = 'id4all-ontwerpen';
  var ICOON_PROPS = ['Gegraveerde icoontjes', 'Gravierte Symbole', 'Icônes gravées', 'Engraved icons'];
  function schoon(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function leesOntwerpen() { try { return JSON.parse(localStorage.getItem(ONTWERP_KEY) || '{}'); } catch (e) { return {}; } }
  function bewaarOntwerp(sleutel, img) {
    try {
      var o = leesOntwerpen(); o[sleutel] = { t: Date.now(), img: img };
      var keys = Object.keys(o).sort(function (a, b) { return o[b].t - o[a].t; });
      keys.slice(12).forEach(function (k) { delete o[k]; });
      localStorage.setItem(ONTWERP_KEY, JSON.stringify(o));
    } catch (e) { /* vol of geblokkeerd: dan maar niet */ }
  }
  function formSleutel(form) {
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return null;
    var waarden = [];
    new FormData(form).forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (!m || typeof v !== 'string') return;
      if (m[1].charAt(0) === '_' || ICOON_PROPS.indexOf(m[1]) !== -1) return;
      if (schoon(v)) waarden.push(schoon(v));
    });
    if (!waarden.length) return null;
    return id.value + '|' + waarden.sort().join('|');
  }
  function rijSleutel(rij) {
    var vid = rij.querySelector('[data-quantity-variant-id]');
    if (!vid) return null;
    var waarden = [];
    rij.querySelectorAll('.id4all-gravuretekst').forEach(function (s) { if (schoon(s.textContent)) waarden.push(schoon(s.textContent)); });
    if (!waarden.length) return null;
    return vid.getAttribute('data-quantity-variant-id') + '|' + waarden.sort().join('|');
  }

  function tekenOntwerp(media) {
    var W = media.clientWidth, H = media.clientHeight;
    if (!W || !H) return null;
    var s = Math.min(2, 600 / W);
    var c = document.createElement('canvas'); c.width = Math.round(W * s); c.height = Math.round(H * s);
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
    var mr = media.getBoundingClientRect();
    media.querySelectorAll('img').forEach(function (img) {
      if (getComputedStyle(img).display === 'none' || !img.complete || !img.naturalWidth) return;
      var r = img.getBoundingClientRect(), fit = getComputedStyle(img).objectFit;
      var x = (r.left - mr.left) * s, y = (r.top - mr.top) * s, w = r.width * s, h = r.height * s;
      var iw = img.naturalWidth, ih = img.naturalHeight, dw = w, dh = h, dx = x, dy = y;
      if (fit === 'contain' || fit === 'cover') {
        var k = fit === 'contain' ? Math.min(w / iw, h / ih) : Math.max(w / iw, h / ih);
        dw = iw * k; dh = ih * k; dx = x + (w - dw) / 2; dy = y + (h - dh) / 2;
      }
      ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
      ctx.drawImage(img, dx, dy, dw, dh); ctx.restore();
    });
    media.querySelectorAll('.live-preview-overlay [class*="preview-text"]').forEach(function (sp) {
      var tekst = sp.textContent;
      if (!tekst.trim() || sp.offsetParent === null) return;
      var cs = getComputedStyle(sp), r = sp.getBoundingClientRect();
      ctx.save();
      ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + (parseFloat(cs.fontSize) * s) + 'px ' + cs.fontFamily;
      if ('letterSpacing' in ctx && cs.letterSpacing && cs.letterSpacing !== 'normal') ctx.letterSpacing = (parseFloat(cs.letterSpacing) * s) + 'px';
      ctx.fillStyle = cs.color; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var sh = /(rgba?\([^)]*\)|#[0-9a-fA-F]{3,8})\s+(-?[\d.]+)px\s+(-?[\d.]+)px(?:\s+([\d.]+)px)?/.exec(cs.textShadow || '');
      if (sh) { ctx.shadowColor = sh[1]; ctx.shadowOffsetX = parseFloat(sh[2]) * s; ctx.shadowOffsetY = parseFloat(sh[3]) * s; ctx.shadowBlur = parseFloat(sh[4] || 0) * s; }
      ctx.fillText(tekst, (r.left - mr.left + r.width / 2) * s, (r.top - mr.top + r.height / 2) * s);
      ctx.restore();
    });
    /* Witte randen boven/onder wegsnijden */
    var d;
    try { d = ctx.getImageData(0, 0, c.width, c.height).data; } catch (e) { return null; }
    var eerste = -1, laatste = -1, CW = c.width;
    for (var y = 0; y < c.height; y += 2) {
      var vol = 0;
      for (var x = 0; x < CW; x += 3) { var p = (y * CW + x) * 4; if (d[p] < 235 || d[p + 1] < 235 || d[p + 2] < 235) vol++; }
      if (vol > CW / 3 * 0.02) { if (eerste < 0) eerste = y; laatste = y; }
    }
    if (eerste < 0) return null;
    var pad = Math.round(c.height * 0.05);
    var top = Math.max(0, eerste - pad), bodem = Math.min(c.height, laatste + pad);
    var uitH = bodem - top, doelW = 300, doelH = Math.round(uitH * doelW / c.width);
    var u = document.createElement('canvas'); u.width = doelW; u.height = doelH;
    var uc = u.getContext('2d'); uc.fillStyle = '#fff'; uc.fillRect(0, 0, doelW, doelH);
    uc.drawImage(c, 0, top, c.width, uitH, 0, 0, doelW, doelH);
    try { return u.toDataURL('image/jpeg', 0.85); } catch (e) { return null; }
  }

  function ontwerpInWinkelwagen(isProduct) {
    var timer = null;
    function bewaarNu(veld) {
      var form = veld && (veld.form || (veld.closest && veld.closest('form')));
      if (!form) form = document.querySelector('product-info form[action*="/cart/add"]');
      if (!form) return;
      var sleutel = formSleutel(form);
      if (!sleutel) return;
      var ov = Array.prototype.find.call(document.querySelectorAll('.live-preview-overlay'), function (o) { return o.offsetParent !== null && !o.closest('.id4all-meeloop'); });
      var media = ov && (ov.closest('.product__media') || ov.parentElement);
      if (!media) return;
      var klaar = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      klaar.then(function () { var img = tekenOntwerp(media); if (img) bewaarOntwerp(sleutel, img); });
    }
    function plan(veld) { clearTimeout(timer); timer = setTimeout(function () { bewaarNu(veld); }, 700); }
    if (isProduct) {
    document.addEventListener('input', function (e) { if (IDS.indexOf(e.target.id) !== -1) plan(e.target); });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects, variant-radios, [name="id"]')) plan(null); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#fun-icons-keyboard, #medical-icons-keyboard')) plan(document.activeElement);
      /* Vlak voor het toevoegen nog één keer, met de laatste stand */
      if (e.target.closest && e.target.closest('.product-form__submit, [name="add"]')) { clearTimeout(timer); bewaarNu(null); }
    }, true);
    }

    /* In de winkelwagen (lade en winkelwagenpagina): het ontwerp op volle breedte boven de regel */
    function pasToe() {
      var o = leesOntwerpen();
      if (!Object.keys(o).length) return;
      document.querySelectorAll('tr.cart-item').forEach(function (rij) {
        var sl = rijSleutel(rij);
        var vorige = rij.previousElementSibling;
        var heeft = vorige && vorige.classList.contains('id4all-ontwerp-rij') ? vorige : null;
        if (!sl || !o[sl]) { if (heeft) heeft.remove(); return; }
        if (heeft && heeft.getAttribute('data-sleutel') === sl) return;
        if (heeft) heeft.remove();
        var tr = document.createElement('tr');
        tr.className = 'id4all-ontwerp-rij';
        tr.setAttribute('data-sleutel', sl);
        var td = document.createElement('td');
        td.colSpan = rij.cells.length || 3;
        var img = document.createElement('img');
        img.className = 'id4all-ontwerp-img';
        img.alt = '';
        img.src = o[sl].img;
        td.appendChild(img); tr.appendChild(td);
        rij.insertAdjacentElement('beforebegin', tr);
      });
    }
    pasToe();
    var gepland = false;
    new MutationObserver(function () {
      if (gepland) return; gepland = true;
      requestAnimationFrame(function () { gepland = false; pasToe(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    /* v24: dit script laadt nu op elke pagina (levertijd en eigen ontwerp in de winkelwagen-lade);
       de productpagina-hulpjes alleen op productpagina's */
    var isProduct = !!document.querySelector('[product-template]');
    function lt() { document.querySelectorAll('[data-levertijd]:not([data-lt-aan])').forEach(function (el) { el.setAttribute('data-lt-aan', ''); levertijd(el); }); }
    lt();
    /* De winkelwagen-lade wordt na toevoegen opnieuw opgebouwd: nieuwe tellers ook starten */
    var ltGepland = false;
    new MutationObserver(function () { if (ltGepland) return; ltGepland = true; requestAnimationFrame(function () { ltGepland = false; lt(); }); })
      .observe(document.body, { childList: true, subtree: true });
    if (isProduct && CFG.stickyKnop) stickyKnop();
    if (isProduct && CFG.meeloop) meeloop();
    if (isProduct && CFG.telefoonCheck !== false) telefoonCheck();
    if (CFG.ontwerpWinkelwagen !== false) ontwerpInWinkelwagen(isProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
